import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import throttle from 'lodash/throttle';
import axios from 'axios';
import SearchResults from './SearchResults';
import {clearAllBodyScrollLocks} from 'body-scroll-lock';

function buildResourceString(obj) {
  return Object.keys(obj)
    .map((param) => `resources[${param}]=${obj[param]}`)
    .join('&');
}

function hideModal() {
  const searchToggleButton = document.querySelector('.header__btn--search');
  const searchCloseButton = document.querySelector('.btn--search-close');
  const searchModal = document.querySelector('.search-modal');
  const searchInput = document.querySelector('.search-input');

  clearAllBodyScrollLocks();
  document.body.classList.remove('search-is-visible');
  searchToggleButton.setAttribute('aria-expanded', false);
  searchCloseButton.setAttribute('aria-expanded', false);
  searchModal.setAttribute('hidden', 'hidden');

  if (searchInput) {
    searchInput.blur();
  }
  window.searchIsVisible = false;
}

function SearchModal() {
  const [searchTerm, setSearchTerm] = useState();
  const [results, setResults] = useState({
    products: [],
    pages: [],
    articles: [],
  });
  const [showResults, setShowResults] = useState(false);

  const rootUrl =
    window.theme.locale && window.theme.locale.primary
      ? ''
      : window.theme.locale.rootUrl;

  const resources = {
    type: window.searchSettings.types.join(','),
    limit: window.searchSettings.limit,
  };
  const unavailableProducts = window.searchSettings.unavailable_products;
  const enableInstantSearch = window.searchSettings.enableInstantSearch;

  useEffect(
    () => {
      if (!searchTerm) {
        setShowResults(false);
        return;
      }
      if (!enableInstantSearch) {
        return;
      }
      const resourceString = buildResourceString(resources);
      axios
        .get(
          `${rootUrl}/search/suggest.json?q=${searchTerm}&${resourceString}&resources[options][unavailable_products]=${unavailableProducts}`,
        )
        .then((res) => {
          const {results: searchResults} = res.data.resources;
          setResults({
            products: searchResults.products || [],
            pages: searchResults.pages || [],
            articles: searchResults.articles || [],
          });
          setShowResults(true);
        });
    },
    [searchTerm],
  );

  const updateSearchTerm = throttle(
    function(value) {
      setSearchTerm(value);
    },
    250,
    {leading: false},
  );

  function handleChange(evt) {
    evt.persist();
    updateSearchTerm(evt.target.value);
  }

  return (
    <React.Fragment>
      <div className="container">
        <div className="row center-xs">
          <div className="col-xs-12 col-sm-10 col-md-8 col-lg-6">
            <h3 className="visually-hidden" id="searchTitle">
              Search
            </h3>
            <form action={`${rootUrl}/search`} method="GET" role="search">
              <div className="has-float-label has-inline-button--right">
                <input
                  name="q"
                  id="SearchInput"
                  autoComplete="off"
                  defaultValue={searchTerm}
                  placeholder={window.theme.strings.search_placeholder}
                  onChange={handleChange}
                  className="search-input"
                  aria-label={window.theme.strings.search_placeholder}
                />
                <label htmlFor="SearchInput">
                  {window.theme.strings.search_label}
                </label>
                <button className="btn--clear" type="submit">
                  {window.theme.strings.search_submit}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {showResults && (
        <SearchResults results={results} searchTerm={searchTerm} />
      )}
      <div className="text-center search-close-wrapper">
        <button
          className="btn btn--text btn--search-close"
          type="button"
          onClick={hideModal}
          aria-expanded="false"
        >
          <svg
            aria-hidden="true"
            focusable="false"
            role="presentation"
            className="icon icon-close-small"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="#000000">
              <path
                d="m3.5-2.2h1v12.3h-1z"
                transform="matrix(.7071 -.7071 .7071 .7071 4.3578 9.9646)"
              />
              <path
                d="m-2.2 3.5h12.3v1h-12.3z"
                transform="matrix(.7071 -.7071 .7071 .7071 4.3078 9.9853)"
              />
            </g>
          </svg>

          <span>Close search</span>
        </button>
      </div>
    </React.Fragment>
  );
}

ReactDOM.render(<SearchModal />, document.getElementById('SearchModal'));
